export default data => {
  const amount = Number.parseInt(data.amount);
  let errors = {};

  if ( !amount ) errors.amount = 'Вкажіть сумму поповнення цілим числом.';

  return errors;
}
